import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import {
  LayoutGrid, ScrollText, BarChart3, Archive, SlidersHorizontal, Bell, LogOut, GitBranch, Users, Rocket, Workflow,
} from "lucide-react";

const NAV = [
  { to: "/", label: "Pipeline", icon: LayoutGrid, end: true },
  { to: "/readiness", label: "Demo Readiness", icon: Rocket },
  { to: "/team", label: "Team", icon: Users },
  { to: "/decisions", label: "Decision Log", icon: ScrollText },
  { to: "/analytics", label: "Analytics", icon: BarChart3 },
  { to: "/register", label: "Park Register", icon: Archive },
  { to: "/alerts", label: "Alerts", icon: Bell },
  { to: "/rubrics", label: "Exit Criteria", icon: SlidersHorizontal },
  { to: "/process", label: "Process Reference", icon: Workflow },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex">
      <aside className="w-60 shrink-0 border-r border-border bg-card flex flex-col sticky top-0 h-screen">
        <div className="p-5 border-b border-border">
          <div className="flex items-center gap-2 text-ai">
            <GitBranch className="w-5 h-5" />
            <span className="font-heading font-extrabold tracking-tight text-lg">VLink Orchestrator</span>
          </div>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-muted-foreground mt-1">
            Spark → Scale
          </p>
        </div>

        <nav className="flex-1 p-3 space-y-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`nav-${n.label.toLowerCase().replace(/ /g, "-")}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 rounded-sm text-sm transition-colors duration-200 ${
                  isActive
                    ? "bg-primary/15 text-white border border-primary/40"
                    : "text-muted-foreground hover:text-white hover:bg-white/[0.04] border border-transparent"
                }`
              }
            >
              <n.icon className="w-4 h-4" />
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="p-3 border-t border-border">
          <div className="flex items-center gap-3 p-2">
            <span
              className="w-9 h-9 rounded-sm flex items-center justify-center text-xs font-bold text-black shrink-0 bg-primary"
            >
              {user?.name?.split(" ").map((n) => n[0]).join("")}
            </span>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold truncate">{user?.name}</p>
              <p className="text-xs text-muted-foreground truncate">{user?.email}</p>
            </div>
            <button
              data-testid="logout-btn"
              onClick={() => { logout(); navigate("/login"); }}
              className="text-muted-foreground hover:text-danger transition-colors duration-200"
            >
              <LogOut className="w-4 h-4" />
            </button>
          </div>
        </div>
      </aside>

      <main className="flex-1 min-w-0 grid-noise">
        <Outlet />
      </main>
    </div>
  );
}
